import { render, staticRenderFns } from "./GallerySmall.vue?vue&type=template&id=8b95729a&scoped=true"
import script from "./GallerySmall.vue?vue&type=script&lang=js"
export * from "./GallerySmall.vue?vue&type=script&lang=js"
import style0 from "./GallerySmall.vue?vue&type=style&index=0&id=8b95729a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b95729a",
  null
  
)

export default component.exports